<template>
  <div class="level-item">
    <template v-if="hasChildren">
      <Dropdown
        :class="{ 'is-hoverable nav-item': isHover }"
        :boundary="boundary"
        :disableToggle="true"
      >
        <slot />
        <template slot="content">
          <slot name="content" />
        </template>
      </Dropdown>
    </template>

    <!-- For standalone links without children such as New Arrivals -->
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
import Dropdown from '@sephora-asia/core-dropdown/Dropdown.vue'

export default {
  name: 'NavItem',

  components: {
    Dropdown
  },

  props: {
    /** Array of children to be displayed in the dropdown */
    children: {
      type: Array,
      default: () => []
    },
    /** Sets the boundary of the dropdown */
    boundary: {
      type: String,
      default: ''
    },
    isHover: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    hasChildren() {
      return this.children && this.children.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.nav-item {
  text-align: center;

  &.is-active,
  &:hover {
    box-shadow: $dropdown-content-shadow;

    // To hide the box-shadow between navbar title and menu
    &::after {
      background: $white;
      bottom: 3px;
      content: '';
      height: 5px;
      width: 100%;
      position: absolute;
      z-index: 20;
    }
  }
}
</style>
